<template>
	<div class="registrationBig" style="background: #f4f4f4;">
		<!-- <div class="headerDiv">
			<div class="fh"> <van-icon name="arrow-left" /> </div>
			<div style="font-weight: 600;">
				报名与查询
			</div>
		</div> -->
		<div class="main">
			<div style="margin-bottom: 0.3rem;">欢迎进入</div>
			<div style="margin-bottom: 0.3rem;" >
				· 如果您是首次使用学习，请点击下方“我要报名”按钮，完成报名后再学习。
			</div>
			<div style="margin-bottom: 0.3rem;">
			· 如果您不清楚是否报名或者参加过学习，点击下方“查询”按钮，进行查询报名与学习情况。
			</div>
			
		</div>
		<div class="btn" @click="signUp" >我要报名</div>
		<div class="btn" @click="query">查询</div>


    <div class="footer">
      <div class="btnBottom">
        <div style="text-align:center">本服务由 内蒙古未知科技有限公司 提供</div>
        <div style="text-align:center">服务热线：18104743612</div>
      </div>
    </div>

	</div>
</template>

<script>
import { Icon } from 'vant';
import request from "@/utils/request";
	export default {
		components: {
		[Icon.name]: Icon,
	},
	data() {
		return {
			
		};
	},
  mounted(){

  },
	created() {

    let code = window.JSON.parse(window.sessionStorage.getItem('thirdCode'));
    if(code== '' ||  typeof(code) == 'undefined' || code == 'null' || code == null) {
      const url = window.location.href;
      const paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
      let paraObj = {};
      for (let i of paraString) {
        paraObj[i.substring(0, i.indexOf("=")).toLowerCase()] = i.substring(i.indexOf("=") + 1, i.length)
      }
      if (typeof (paraObj) != "undefined") {
        code = paraObj["code"];
        if( typeof(code) !='undefined' && code != '' && code !='null') {
          //请求后台，获取用户名和手机号、身份证号
          let urls = Global.env + Global.apiCore.listForEnroll;
          return new Promise((resolve, reject) => {
            request({
              url: urls,
              method: "post",
              data: {
                code:code,
              },
            }).then((response) => {

              if (response.resultCode == "1000") {
                let realName = response.data.realName;
                window.sessionStorage.setItem("thirdRealName", window.JSON.stringify(realName));
                let mobilePhone = response.data.mobilePhone;
                window.sessionStorage.setItem("thirdMobilePhone", window.JSON.stringify(mobilePhone));
                let idCard = response.data.idCard;
                window.sessionStorage.setItem("thirdIdCard", window.JSON.stringify(idCard));
              }
            }).catch((error) => {
              alert("请求异常")
            });
          });
          window.sessionStorage.setItem("thirdCode", window.JSON.stringify(code));
        }

		    this.hef();

      }

    }



  },
		methods: {
			hef(){
				window.location.href='https://app.zwfw.nmg.gov.cn:4443/icity/auth2.0/authorize?app_id=9a60f546-05dd-43b0-a86e-569a9e1647fa&redirect_uri=http%3A%2F%2Fm-test.jiaodao11.com%2Fregistration&scope=base_info,auth_user&state={"app_info":"aaaa"}'
			},
			signUp() {
				this.$router.push({
					name: 'RegistrationPage',
					query: {}
				})
			},
			query() {
				this.$router.push({
					name: 'ToQuery',
					query: {}
				})
			},
      listForEnroll(code) {

        let urls = Global.env + Global.apiCore.listForEnroll;
        alert(urls+"----"+code);
        return new Promise((resolve, reject) => {
          request({
            url: urls,
            method: "post",
            data: {
              code: code,
            },
          }).then((response) => {
               alert("---111---");
               alert(response.data)
          }).catch((error) => {
            alert("error")
          });
        });
      },
		}
	}
</script>

<style scoped>
.registrationBig{
	overflow: hidden;
	height: 100%;
}
.headerDiv{
	position: relative;
	height: 0.7rem;
	text-align: center;
	line-height: 0.7rem;
	font-size: 0.26rem;
	border-bottom: 0.02rem solid #EEEEEE;
}
.fh{
	position: absolute;
	left: 0.1rem;
	top: 50%;
	transform: translate(0,-50%);

}
.main{
	width: 91%;
	margin: 0 auto;
	font-size: 0.3rem;
	line-height: 0.52rem;
	font-weight: 400;
	background: #fff;
	padding: 3%;
	margin-top: 0.2rem;
	margin-bottom: 0.3rem;
}
.btn {
	width: 94%;
	height: 0.82rem;
	line-height: 0.82rem;
	background: #00ae7e;
	border-radius: 4px;
	margin: 0 auto;
	margin-top: 0.15rem;
	text-align: center;
	font-weight: 400;
	color: rgba(255, 255, 255, 1);
	font-size: 0.3rem;
}
.footer {
  border-top: 1px solid rgba(255, 255, 255, 1);

  bottom:0px;
  height:1rem;
  width: 91%;
  position: fixed;
  bottom:0;
  left:0;
  .btnBottom {
    margin: 12px 24px 0 0;
    justify-content: flex-end;
    display: flex;
  }
}

</style>
